<template>
  <div class="AddLogo">
    <v-btn
      class="AddLogo-button secondary--text"
      :color="logoUrl ? 'transparent' : 'secondary lighten-1'"
      @click="$refs.logoFile.click()"
      depressed
      :style="{ 'background-image': logoUrl }"
      tile
    >
      <template v-if="!logoUrl">
        {{ $t('addLogo.buttonName') }}
      </template>
    </v-btn>

    <input ref="logoFile" type="file" accept="image/png, image/jpeg" class="d-none" @change="changeLogo" />
  </div>
</template>

<script>
import { toBase64 } from '@/services/file'

export default {
  name: 'AddLogo',

  props: {
    value: File,
    logoLink: String
  },

  data() {
    return {
      logoData: ''
    }
  },

  computed: {
    logoUrl() {
      if (!this.logoData && !this.logoLink) return null

      let urlRandomString = Math.random()
        .toString(36)
        .substring(7)
      const fullLogoLink = `${window.location.origin}/shop/logo/${this.logoLink}?${urlRandomString}`
      return `url(${this.logoData || fullLogoLink})`
    }
  },

  async mounted() {
    if (this.$store.state.pendingLogo) {
      this.logoData = await toBase64(this.$store.state.pendingLogo)
    }
  },

  methods: {
    async changeLogo() {
      const file = this.$refs.logoFile.files[0]
      this.$store.commit('SET_PENDING_LOGO', this.$refs.logoFile.files[0])
      this.$emit('input', file)
      this.logoData = await toBase64(file)
    }
  }
}
</script>

<style scoped lang="scss">
.AddLogo {
  width: 100%;
  height: 100%;
}

.AddLogo-button {
  width: 100% !important;
  height: 100% !important;
  background-size: contain;
  background-position: center;
}
</style>
